import React, { useState } from "react";
import { toast } from "sonner";
import { fmtDate, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Textarea } from "../../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../../components/ui/dialog";

export const HANDLING_LABELS = {
  manual_keep: "Sudah Keep Manual",
  cancel_transaction: "Cancel Transaksi",
  cashier: "Sudah Kasir",
  return: "Return",
  other: "Lainnya",
};
const OPTIONS = {
  keep: ["manual_keep", "cancel_transaction", "cashier", "other"],
  cancel: ["cancel_transaction", "return", "other"],
};

export const HandlingDetails = ({ row, kind }) => {
  const prefix = kind === "keep" ? "resolved" : "handled";
  const action = row[`${prefix}_action`];
  const note = row[`${prefix}_note`];
  return (
    <div className="space-y-1 text-xs [overflow-wrap:anywhere]" data-testid={`ak-${kind}-handling-details-${row.order_sn}`}>
      <div className="font-medium text-cocoa" data-testid={`ak-${kind}-handling-category-${row.order_sn}`}>
        {HANDLING_LABELS[action] || (row[`${prefix}_by`] === "system" ? "Otomatis oleh sistem" : "Kategori belum dicatat")}
      </div>
      {note && <div className="text-cocoa/70 whitespace-pre-wrap" data-testid={`ak-${kind}-handling-note-${row.order_sn}`}>{note}</div>}
      <div className="text-cocoa/60" data-testid={`ak-${kind}-handler-${row.order_sn}`}>
        {row[`${prefix}_by`] || "Tim"} · {fmtDate(row[`${prefix}_at`])}
      </div>
    </div>
  );
};

export const HandlingDialog = ({ target, onClose, onConfirm }) => {
  const [action, setAction] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!action || (action === "other" && !note.trim()) || saving) return;
    setSaving(true);
    try { await onConfirm({ action, note: note.trim() }); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <Dialog open onOpenChange={(open) => { if (!open && !saving) onClose(); }}>
      <DialogContent className="w-[calc(100%-2rem)] sm:max-w-lg" data-testid="handling-dialog"
        onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle data-testid="handling-title">Sudah Ditangani · Auto {target.kind === "keep" ? "Keep" : "Cancel"}</DialogTitle>
          <DialogDescription data-testid="handling-description">
            Catat tindakan yang sudah dilakukan. Pilihan ini tidak membuat Keep, Sales, pembatalan, atau retur dan tidak mengubah stok.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm [overflow-wrap:anywhere]" data-testid="handling-target">
            {target.bulk ? `${target.orderSns.length} order terpilih — pilihan diterapkan ke semua order yang masih gagal.` : `Order ${target.orderSns[0]}`}
          </p>
          <fieldset disabled={saving} className="space-y-2">
            <legend className="mb-2 text-sm font-medium">Jenis penanganan</legend>
            {OPTIONS[target.kind].map((value) => (
              <label key={value} className={`flex cursor-pointer items-center gap-3 rounded-md border px-3 py-2.5 text-sm transition-colors ${action === value ? "border-cocoa bg-cocoa/5" : "hover:bg-cocoa/5"}`}>
                <input type="radio" name="handling-action" value={value} checked={action === value}
                  onChange={() => setAction(value)} className="accent-cocoa" data-testid={`handling-option-${value}`} />
                {HANDLING_LABELS[value]}
              </label>
            ))}
          </fieldset>
          <label className="block text-sm font-medium" htmlFor="handling-note">
            Keterangan {action === "other" ? "(wajib)" : "(opsional)"}
            <Textarea id="handling-note" value={note} onChange={(e) => setNote(e.target.value)} disabled={saving}
              maxLength={1000} required={action === "other"} rows={3} className="mt-1.5"
              placeholder="Tuliskan penanganan yang sudah dilakukan…" data-testid="handling-note" />
          </label>
          {action === "other" && !note.trim() && <p className="text-xs text-amber-700" data-testid="handling-note-required">Isi keterangan untuk pilihan Lainnya.</p>}
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="handling-cancel">Batal</Button>
            <Button type="submit" disabled={saving || !action || (action === "other" && !note.trim())} data-testid="handling-submit">
              {saving ? "Menyimpan…" : "Simpan Penanganan"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
